import { STORAGE_KEYS } from "@/constants/storage";

export type PendingBookingPayload = {
  firstName: string;
  lastName: string;
  userEmail: string;
  userPhoneNumber: string;
  dateOfBirth: string;
  specialistId: string;
  timeSlotId: string;
  appointmentDate: string;
  visitType: number;
  symptoms: string;
  locationId?: string;
  searchedZipCode?: string;
  smsConsent?: boolean;
};

// The booking route's search params, kept alongside the pending booking so a
// patient sent to login (e.g. to add a card on their first appointment) can be
// returned to the fully-populated booking form afterwards.
export type PendingBookingSearch = Record<string, string | undefined>;

export const authCoordinator = {
  storePendingBooking(payload: PendingBookingPayload): void {
    sessionStorage.setItem(STORAGE_KEYS.PENDING_BOOKING, JSON.stringify(payload));
  },
  getPendingBooking(): PendingBookingPayload | null {
    const raw = sessionStorage.getItem(STORAGE_KEYS.PENDING_BOOKING);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as PendingBookingPayload;
    } catch {
      return null;
    }
  },
  storePendingBookingSearch(search: PendingBookingSearch): void {
    sessionStorage.setItem(
      STORAGE_KEYS.PENDING_BOOKING_SEARCH,
      JSON.stringify(search),
    );
  },
  getPendingBookingSearch(): PendingBookingSearch | null {
    const raw = sessionStorage.getItem(STORAGE_KEYS.PENDING_BOOKING_SEARCH);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as PendingBookingSearch;
    } catch {
      return null;
    }
  },
  clearPendingBooking(): void {
    sessionStorage.removeItem(STORAGE_KEYS.PENDING_BOOKING);
    sessionStorage.removeItem(STORAGE_KEYS.PENDING_BOOKING_SEARCH);
  },
  redirectToLoginWithEmail(email: string): void {
    const params = new URLSearchParams({ email });
    window.location.href = `/login?${params}`;
  },
};
